<template>
    <div class="con">
        <Card>
            <div class="check-station">
                <div class="title-check">Something wrong!</div>
                <div class="img-container">
                    <img src="../assets/CloseLocker.png">
                </div>
                <p>Please close the locker or charge battery that you replace.</p>
                <span @click="routeTo('ChangeComplete')">
                    <!-- <Button disabled class="next-btn disabled">COMPLETE</Button> -->
                    <!-- <Button class="next-btn">COMPLETE</Button> -->
                    <!-- <Button :disabled="isDisabled" :class="isDisabled ? 'disabled' : 'next-btn'"
                        @click="routeTo('ChangeComplete')">NEXT</Button> -->
                    <Button :disabled="selectedSlot.id === 10 && selectedSlot.station_id === 1"
                        :class="selectedSlot.id === 10 && selectedSlot.station_id === 1 ? 'disabled' : 'next-btn'"
                        @click="routeTo('ChangeComplete')">NEXT</Button>
                </span>
            </div>

        </Card>
    </div>
</template>
  
<script>
import Button from "../components/Button.vue"
import Card from "../components/Card.vue"


export default {
    name: "CloseLocker",
    components: {
        Button,
        Card
    },
    data() {
        return {
            // isDisabled: true,
            selectedSlot: '',
        }
    },
    methods: {
        routeTo(route) {
            if (!route) return
            console.log(route)
            this.$router.push({ name: route, query: { slot: this.selectedSlot } })
        }
    },
    created() {
        // setTimeout(() => {
        //     this.isDisabled = false;
        // }, 2000),

        this.selectedSlot = this.$route.query.slot;
        console.log(this.selectedSlot.station_id)
        console.log(this.selectedSlot.id)
        console.log(this.selectedSlot.no)
    },
}
</script>
  
<style scoped>
.con {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
}

.check-station {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 325px;
    height: 430px;
    padding: 24px;
}

.title-check {
    font-size: 24px;
    font-weight: 700;
    color: #DF3C2F;
    /* margin-bottom: 30px; */
}

.img-container {
    width: 267px;
    height: 267px;
}

p {
    text-align: center;
    position: relative;
    font-size: 14px;
    color: #8E8E8E;
    /* margin-top: 16px; */
}

.next-btn {
    width: 155px !important;
    height: 56px !important;
    color: #fff;
}

.disabled {
    width: 155px !important;
    height: 56px !important;
    background: #D9D9D9 !important;
    cursor: auto;
    color: #fff;
}
</style>